import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/pwa";
import { hydrateStorage } from "@/lib/storage";
import { initNativeShell } from "@/lib/native";

const root = ReactDOM.createRoot(document.getElementById("root"));

const render = () =>
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

// On native, device storage has to be read into memory before the first render:
// the library reads it synchronously, so rendering first would briefly show an
// empty history and an unsaved state for everything. Resolves immediately on web.
hydrateStorage()
  .catch(() => {})
  .finally(() => {
    render();
    initNativeShell();
  });

// Installable app plus an offline shell. No-op in development - see lib/pwa.js.
registerServiceWorker();
